import Swiper, { Autoplay, Navigation } from 'swiper';

const VACANCIES_WRAPPER_SELECTOR = '.vacancies-swiper-wr';
const MOBILE_BREAKPOINT = '(max-width: 1023px)';
const resizeVacanciesMediaQueries = new Map();

function wrapperElements(root = document) {
  const wrappers = [...root.querySelectorAll(VACANCIES_WRAPPER_SELECTOR)];

  if (root.matches?.(VACANCIES_WRAPPER_SELECTOR)) {
    wrappers.unshift(root);
  }

  return wrappers;
}

function destroySwiperInstance(state) {
  if (state.swiper && !state.swiper.destroyed) {
    state.swiper.destroy(true, true);
  }

  state.swiper = null;
}

function syncResizeVacanciesSwiper(state) {
  if (!state.mediaQuery.matches) {
    destroySwiperInstance(state);
    return;
  }

  if (state.swiper && !state.swiper.destroyed) {
    return;
  }

  const swiperElement = state.wrapper.querySelector('.swiper');

  if (!swiperElement) {
    return;
  }

  state.swiper = new Swiper(swiperElement, {
    modules: [Autoplay, Navigation],
    slidesPerView: 1,
    spaceBetween: 12,
    autoplay: {
      delay: 4000,
      disableOnInteraction: false,
      pauseOnMouseEnter: false,
    },
    breakpoints: {
      641: {
        slidesPerView: 1,
        spaceBetween: 20,
      },
    },
    navigation: {
      prevEl: state.wrapper.querySelector('.swiper-button-prev'),
      nextEl: state.wrapper.querySelector('.swiper-button-next'),
    },
  });
}

function initVacanciesSwiper(wrapper) {
  if (resizeVacanciesMediaQueries.has(wrapper)) {
    return;
  }

  const state = {
    wrapper,
    mediaQuery: window.matchMedia(MOBILE_BREAKPOINT),
    swiper: null,
    listener: null,
  };

  state.listener = () => syncResizeVacanciesSwiper(state);
  state.mediaQuery.addEventListener('change', state.listener);
  resizeVacanciesMediaQueries.set(wrapper, state);
  syncResizeVacanciesSwiper(state);
}

function destroyVacanciesSwiper(root = document) {
  wrapperElements(root).forEach((wrapper) => {
    const state = resizeVacanciesMediaQueries.get(wrapper);

    if (!state) {
      return;
    }

    state.mediaQuery.removeEventListener('change', state.listener);
    destroySwiperInstance(state);
    resizeVacanciesMediaQueries.delete(wrapper);
  });
}

function refreshVacanciesSwiper(root = document) {
  destroyVacanciesSwiper(root);
  wrapperElements(root).forEach(initVacanciesSwiper);
}

window.destroyVacanciesSwiper = destroyVacanciesSwiper;
window.refreshVacanciesSwiper = refreshVacanciesSwiper;

refreshVacanciesSwiper();
